import { State } from '@energy-retailer/constants';
import Link from 'next/link';

import { Text } from '@/components/text';

type TariffQuoteTextProps = {
  hasAddress: boolean;
  state: State;
  docsHref: string;
};

const TariffQuoteText = ({
  hasAddress,
  state,
  docsHref,
}: TariffQuoteTextProps) => {
  const stateText = (
    <Text
      variant="body2"
      as="span"
    >
      Please refer to the{' '}
      <Link
        className="text-body2 text-info underline decoration-info"
        href={docsHref}
        target="_blank"
      >
        {state === State.VIC
          ? 'Energy Fact Sheet'
          : 'Basic Plan Information Document'}
      </Link>{' '}
      for more details
    </Text>
  );

  return (
    <Text variant="body2">
      Your property may have a different tariff type. Some tariff combinations
      are subject to seasonal changes and have differing peak and off-peak
      times.{' '}
      {hasAddress ? stateText : 'Add your address for more accurate quotes.'}
    </Text>
  );
};

export { TariffQuoteText };
